import { CSSProperties } from "react";

export const getColor = (state: any): CSSProperties["color"] => {
	return state.selectProps?.brandingColor ? "#13acc5" : "#747474";
};

export const getBorderColor = (state: any): CSSProperties["borderColor"] => {
	if (state.selectProps.hasError) {
		return "rgba(242, 90, 90, 0.7)";
	} else if (state.selectProps.hasWarning) {
		return "rgba(255, 192, 0, 0.7)";
	} else {
		return "#616161";
	}
};

export const getBoxShadow = (state: any): CSSProperties["boxShadow"] => {
	if (!state.isFocused) return;

	if (state.selectProps.hasError) {
		return "0 0 0 0.2rem rgba(242, 90, 90, 0.15)";
	} else if (state.selectProps.hasWarning) {
		return "0 0 0 0.2rem rgba(255, 192, 0, 0.15)";
	} else {
		return "0 0 0 0.2rem rgba(255, 255, 255, 0.15)";
	}
};

export const getFontStyle = (state: any): CSSProperties["fontStyle"] => {
	if (state.data.active || state.data.active === undefined) {
		return "normal";
	} else {
		return "italic";
	}
};

export const getSubOptionPaddingLeft = (
	state: any,
): CSSProperties["paddingLeft"] => {
	const isSubOption = state.selectProps?.isSubOption?.(state.data);
	return isSubOption && 24;
};

export const getOptionColor = (state: any): CSSProperties["color"] => {
	const disabled = state.selectProps.isOptionDisabled(state.data);
	const color = disabled ? "#747474" : "rgba(255, 255, 255, 0.7)";
	return color;
};

export const getOptionBackground = (
	state: any,
): CSSProperties["backgroundColor"] => {
	return !state.selectProps.isOptionDisabled(state.data)
		? "#13acc5"
		: undefined;
};
